import { extendMoment } from 'moment-range';
import 'moment-timezone';
import moment from 'moment';
import '../../config/yup-config';
import '../../services/translations';

extendMoment(moment);